export class ClDatosConsumidor {
    Alergias: string;
    Alergias2: AlergiasConsumidor[];
    AnimalesDomesticos: any[];
    AnoDeNacimiento: number;
    Apellido1: string;
    Apellido2: string;
    Ciudad: string;
    ClaveAPP: string;
    CodPostal: string;
    ComoNosHasConocido: string;
    ComprasPorInternet: boolean;
    Contador: number;
    DiaDeNacimiento: number;
    Direccion: string;
    Disponibilidad: any[];
    Email: string;
    Especialidad: string;
    EstablecimientosDeCompra: any[];
    EstadoCivil: string;
    FechaDeNacimiento: string;
    Hijo: boolean;
    IBAN: string;
    ContadorPadre: number;
    IngresosFamiliares: number;
    MesDeNacimiento: number;
    MotivoNoApp: number;
    NIF: string;
    Nacionalidad: string;
    NivelEstudios: string;
    Nombre: string;
    OtrosPanelConsumidores: boolean;
    PersonasConviven: any[];
    PersonasEnElHogar: number;
    PersonasTrabajan: number;
    Poblacion: string;
    ProductosCosmetica: number;
    ProductosFamiliar: any[];
    Profesion: string;
    ProfesionConyuge: string;
    Provincia: string;
    ResponsableDeLaCompra: string;
    SectorEmpresa: string;
    Sexo: string;
    TelefonoFijo: string;
    TelefonoMovil: string;
    TipoAlta: string;
    ProductosPorcentajes: any[];
    HorariosDisponibles: HorariosConsumidor[];
    InfoHijos: any[];
    AceptaPoliticaPrivacidad: boolean;
    AceptaUsuDatosEncuestas: boolean;
    PoliticaPrivacidadAceptada: Boolean;
    SoloEstudiosOnLine: boolean;
    Online: boolean;
    Presencial: boolean;
    Domicilio: boolean;
  }
  export class AlergiasConsumidor {
      Alergia: number;
      Contador: number;
      Descripcion: string;
      LlevaDescripcion: boolean;
      Alergico: boolean;
  }

  export class Bonificacion {
    Fecha: Date;
    Id: number;
    Importe: string;
    NumeroAsignado: string;
    strFecha: string;
    url: string;

    constructor(){
        this.Fecha=null;
        this.Id=null;
        this.Importe=null;
        this.NumeroAsignado=null;
        this.strFecha=null;
        this.url=null;
    }
  }
  export class AlergiasBase {
    Alergia: number;
    Contador: number;
    Descripcion: string;
    LlevaDescripcion: boolean;
    Alergico: boolean;
}

export class HorariosConsumidor {
    Hora: boolean;
    Contador: number;
    Texto: string;
}
export class AltaPendienteRegistro {
    Email: string;
    Pass: string;
}
// tslint:disable-next-line:class-name
export class infoHijos {
AnoDeNacimiento: number;
Contador: number;
DiaDeNacimiento: number;
MesDeNacimiento: number;
Nombre: string;
Apellido1: string;
Apellido2: string;
Sexo: string;
}
// tslint:disable-next-line:class-name
export class estudiosConsumidor {
Cerrado: string;
ContadorEstudio: number;
Direccion: string;
Enlace: string;
Estado: string;
Inscripcion: string;
Remuneracion: number;
Telefono: string;
TituloEstudio: string;
EstudioRealizado: boolean;
Cancelacion: boolean;
Falta: boolean;
Hombre: boolean;
Hijo: boolean;
NombreHijo: boolean;
ContadorConsumidor: number;
IBAN: boolean;
IdGratificacion:number;
}
// tslint:disable-next-line:class-name
export class datosChat {
ContadorConsumidor: number;
NombreConsumidor: string;
}



// WEBPACK FOOTER //
// ./src/app/utils/dtos/clDatosConsumidor.ts